module.exports = __webpack_public_path__ + "static/media/Discovery_divein.6eadfc29.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-ASURION/Discovery_divein.svg
// module id = 1380
// module chunks = 0